<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
    >
      <search-item
        config-module="410015205"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--确认-->
          <el-button type="success" no="2" @click="confirmHandler()">{{ this.$t('CargoMsg.Cargo_ConfirmR') }}</el-button>
          <!--拒绝-->
          <el-button type="danger" no="3" @click="rejectHandler()">{{ this.$t('CargoMsg.Cargo_Refuse') }}</el-button>
          <!--拒绝-->
          <!--<el-button type="danger" @click="revokeAll()">{{ this.$t('CargoMsg.Cargo_RevokeAll') }}</el-button>-->
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015205"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <div v-show="rowData" :class="'fixedBottom'" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <span v-show="selectedDataList.length > 0">
            {{ this.$t('CargoMsg.Cargo_Choose') + selectedDataList.length + ':' }}
          </span>
          <charge-currency-total-group
            v-if="reCalc"
            :key="1"
            :type="'revenue'"
            :amount-to-currency="localCurrency"
            :currency-field="'billingCurrency'"
            :data-field="'clearAmountString'"
            :data-provider="selectedDataList.length > 0 ?selectedDataList:rowData"
            :ar-field="'ar'"
          />
          <span>
            {{ this.$t('CargoMsg.Cargo_TotalWriteOffAmount') }}
          </span>
        </div>
        <cargo-pagination
          config-module="410015205"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          @pagination="toQuery"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import { getLoading } from '@/utils/utilBaseElement'
import { batchConfirm, batchReject, queryClearHistoryPageableFast } from '@/api/clearing/clearHistory'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import $store from '@/store'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'OfficeConfirmNew',
  components: {
    searchItem,
    chargeCurrencyTotalGroup
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      URL,
      isAdvancedQuery: false, // 是否为高级查询
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      fullscreenLoading: null,
      selectedDataList: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 行勾选事件
        onRowSelected: this.onRowSelected,
        frameworkComponents: {
          RouterAndPrintRenderer
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'jobNo', colId: 'jobNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', colId: 'billingNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'businessDate', colId: 'businessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'poNo', colId: 'poNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'), field: 'ar', width: 100, colId: 'ar',
          valueFormatter: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'realClearingState', colId: 'realClearingState', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', colId: 'settlementAgentId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffCurrency'), colId: 'clearCurrency', field: 'clearCurrency'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TotalWriteOffAmount'), colId: 'clearAmount', field: 'clearAmount',
          valueFormatter: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffRate'), colId: 'clearRate', field: 'clearRate',
          valueFormatter: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 8)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OriginalCurrencyInBill'), colId: 'billingCurrency', field: 'billingCurrency'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OriginalAmountInBill'), colId: 'billingAmount', field: 'billingAmount',
          valueFormatter: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_OriginalExchangeRateInBill'), field: 'billingRate', colId: 'billingRate',
          valueFormatter: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 8)
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'writeOffDate', colId: 'writeOffDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_SentDate'), field: 'notifyDate', colId: 'notifyDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ConfirmDate'), field: 'confirmDate', colId: 'confirmDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ConfirmStatus'), field: 'confirmState', colId: 'confirmState', width: 200,
          valueFormatter: (params) => {
            const state = CommonState.getStateByCode(ClearingConstants.CLEAR_HISTORY_STATES_ALL, params.value)
            const language = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
            return state === null ? this.$t('CargoMsg.Cargo_Unconfirmed') : state[language]
          } },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'clearRemark', colId: 'clearRemark', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_ArOriginalCurrency'), field: 'receivableCurrency', colId: 'receivableCurrency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffSerialNumber'), field: 'actualAmountNos', colId: 'actualAmountNos', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_ApOriginalCurrency'), field: 'payableCurrency', colId: 'payableCurrency', width: 200 }],
      queryBranchId: 0 // 点击查询时的分公司
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    }
  },
  watch: {
    // '$store.getters.currentOfficeId': function() {
    //   this.toQuery()
    // }
  },
  created() {
    this.setLocalCurrency()
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.requires = ['officeConfirmNew']
      this.filter.isAdvancedQuery = false
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      this.queryBranchId = this.$store.getters.currentOfficeId
      queryClearHistoryPageableFast(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridApi, 'uuid')
      this.rowData = []
      for (const data of res.data.list) {
        if (data) {
          data.clearAmountString = data.clearAmount * (data.ar ? 1 : -1)
          this.rowData.push(data)
        }
      }
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.selectedDataList = []
      this.fullscreenLoading.close()
      selectedStatus.revert()
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    toAdvancedQuery(data) {
      console.log('----toAdvancedQuery----')
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      if (!AdvancedSearchOption.hasField('clearHistory.VERIFICATIONDATE', this.filterJson.conditions)) {
        this.$message.warning(this.$t('WriteOff.writeOffDateNotEmpty'))
        return
      }
      this.filterJson.requires = ['officeConfirmNew']
      this.filterJson.isAdvancedQuery = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.groups = ['billing.UUID', 'clearHistory.CONFIRM_STATE']
      this.fullscreenLoading = getLoading()
      this.queryBranchId = this.$store.getters.currentOfficeId
      queryClearHistoryPageableFast(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    confirmHandler() {
      if (this.queryBranchId > 0 && this.queryBranchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceQueryBranch'))
        return
      }
      const selectRows = this.gridOptions.api.getSelectedRows()
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      let chs = []
      const billingKeys = []
      for (const item of selectRows) {
        if (item['confirmState'] === ClearingConstants.CLEAR_HISTORY_STATE_UNCONFIRMED.code) {
          const clearHistoryKeys = item['clearHistoryKeys']
          const r = clearHistoryKeys.split(',')
          chs = chs.concat(r)
          billingKeys.push(item['billingKey'])
        }
      }

      if (chs.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllSelectedRecordsConfirmed'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToConfirmWriteOffRecord'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        batchConfirm({ billingKeys: billingKeys, clearHistoryKeys: chs }).then(res => {
          this.fullscreenLoading.close()
          this.$message.warning(this.$t('CargoMsg.Cargo_ConfirmedSuccessfully'))
          this.toQuery()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    rejectHandler() {
      if (this.queryBranchId > 0 && this.queryBranchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckInvoiceQueryBranch'))
        return
      }
      const selectRows = this.gridOptions.api.getSelectedRows()
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffRecord'))
        return
      }
      let chs = []
      for (const item of selectRows) {
        if (item['confirmState'] === ClearingConstants.CLEAR_HISTORY_STATE_UNCONFIRMED.code) {
          const clearHistoryKeys = item['clearHistoryKeys']
          const r = clearHistoryKeys.split(',')
          chs = chs.concat(r)
        }
      }
      if (chs.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ASRCCTD'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDeny'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        batchReject(chs).then(res => {
          this.fullscreenLoading.close()
          this.$message.warning(this.$t('CargoMsg.Cargo_DeniedSuccessfully'))
          this.toQuery()
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
